import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({ providedIn: 'root' })
export class ServiceMgmtService {

  private url = ConfigService.toApiUrl('v1/services/');

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<any>(`${this.url}`,
      ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }

  get(id: any) {
    return this.http.get<any>(`${this.url}${id}`,
      ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }

  setActive(id: any, isActive: boolean) {
    return this.http.patch<any>(
      `${this.url}${id}`,
      { is_active: isActive },
      ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true)
    );
  }

  delete(id: any) {
    return this.http.delete<any>(`${this.url}${id}`,
      ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }
}
